import api from './api';

function unwrap(response, fallback) {
  const body = response?.data || {};
  if (body.error || body.code !== 200) throw new Error(body.message || fallback);
  return body.dataset?.data;
}

export async function fetchSubjectPlans(stateId) {
  const response = await api.get('/subscription/subject-subscriptions', { params: { states_id: stateId } });
  return unwrap(response, 'Unable to load subject plans.') || {};
}

export async function fetchUserSubjectSubscriptions(stateId) {
  let response;
  try {
    response = await api.get('/subscription/user-subject-subscriptions', { params: { states_id: stateId } });
  } catch (error) {
    if (/no active .*subject.*subscriptions? found/i.test(error.message || '')) return { subscriptions: [] };
    throw error;
  }
  if (/no active .*subject.*subscriptions? found/i.test(response?.data?.message || '')) return { subscriptions: [] };
  return unwrap(response, 'Unable to load your subject subscriptions.') || {};
}

export async function fetchSubjectDiscount(payload) {
  return unwrap(await api.post('/subscription/subject-subscription-discount', payload), 'Unable to confirm subject discount.') || {};
}

export async function createSubjectOrder(payload) {
  const order = unwrap(await api.post('/subscription/generate-order', payload), 'Unable to create subject order.') || {};
  if (!order.vk_order_id) throw new Error('The server did not return an order ID.');
  return order;
}

export async function fetchSubjectGateways(subscriptionIds, couponCode = '') {
  const response = await api.get('/payment/get-payment-gateway', {
    params: {
      platform: process.env.REACT_APP_SUBJECT_PAYMENT_PLATFORM || 'web',
      subject_subscription_ids: subscriptionIds,
      ...(couponCode ? { coupon_code: couponCode } : {}),
    },
  });
  const data = unwrap(response, 'Unable to load subject payment methods.');
  return Array.isArray(data) ? data : [];
}
